"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var provider_1 = require("../../../theme/provider");
var utils_1 = require("../../../utils/utils");
// Main button with styles
var StyledAnchor = (0, styled_components_1.default)("a")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.55em;\n  cursor: pointer;\n  -webkit-font-smoothing: antialiased;\n  text-decoration: none;\n  display: inline-block;\n  position: relative;\n\n  & > * {\n    vertical-align: middle;\n    transition: color 0.3s ease-out;\n  }\n  & > svg {\n    margin: 0 0.5em;\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    /* transform: ", "; */\n    height: 1px;\n    bottom: 0;\n    left: 0;\n    /* background-color: ", "; */\n    /* transform-origin: ", ";\n    transition: transform 0.25s ease-out; */\n  }\n\n  &:hover,\n  &:active {\n    * {\n      color: ", ";\n    }\n\n    &:after {\n      /* transform: ", ";\n      transform-origin: bottom left; */\n    }\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.55em;\n  cursor: pointer;\n  -webkit-font-smoothing: antialiased;\n  text-decoration: none;\n  display: inline-block;\n  position: relative;\n\n  & > * {\n    vertical-align: middle;\n    transition: color 0.3s ease-out;\n  }\n  & > svg {\n    margin: 0 0.5em;\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    /* transform: ", "; */\n    height: 1px;\n    bottom: 0;\n    left: 0;\n    /* background-color: ", "; */\n    /* transform-origin: ", ";\n    transition: transform 0.25s ease-out; */\n  }\n\n  &:hover,\n  &:active {\n    * {\n      color: ", ";\n    }\n\n    &:after {\n      /* transform: ", ";\n      transform-origin: bottom left; */\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.gray5, theme.gray1, "black");
}, function (props) {
    return props.theme ? (0, provider_1.getFontFromTheme)(props.theme).fontFamily : "sans-serif";
}, function (props) {
    return props.underline ? "scaleX(1)" : "scaleX(0)";
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.gray5, theme.gray1, "black");
}, function (props) {
    return props.underline ? "bottom left" : "bottom right";
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
}, function (props) { return (props.underline ? "scaleX(0)" : "scaleX(1)"); });
var Link = function (_a) {
    var _b;
    var _c = _a.underline, underline = _c === void 0 ? false : _c, props = __rest(_a, ["underline"]);
    return ((0, jsx_runtime_1.jsx)(StyledAnchor, __assign({ underline: underline }, props, { className: "wellms-component ".concat((_b = props.className) !== null && _b !== void 0 ? _b : "") }, { children: props.children })));
};
exports.Link = Link;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
